{
	"title": "Курсы",
	"subtitle": "Курсы, темы и то, чем заняться дальше",
	"eyebrow": "Курс",
	"list": {
		"title": "Курсы",
		"empty": "Курсов пока нет",
		"emptyHint": "Курс превращает материалы в программу: темы в рабочем порядке, к каждой — конспект, карточки и тест.",
		"emptyCta": "Создай курс",
		"create": "Создать курс",
		"createTitle": "Новый курс",
		"createSubtitle": "Назови курс и добавь материалы — построим программу.",
		"createNameLabel": "Название курса",
		"createNamePlaceholder": "Например, Матанализ, 2 семестр",
		"createExamLabel": "Дата экзамена (необязательно)",
		"createGoalLabel": "Цель (необязательно)",
		"createGoalPlaceholder": "Например: сдать ЕГЭ на 80+ баллов",
		"createGoalHint": "К чему готовимся. Влияет на состав программы и на то, что подсказывает репетитор.",
		"createSubmit": "Создать",
		"createCancel": "Отмена",
		"createSuccess": "Курс создан",
		"createError": "Не удалось создать курс",
		"defaultTitle": "Мой курс",
		"search": "Поиск курса",
		"noMatches": "Под фильтр ничего не подошло",
		"segments": {
			"active": "Активные",
			"completed": "Завершённые",
			"archived": "Архив",
			"all": "Все"
		},
		"calendar": "Учебный календарь",
		"templates": "Шаблоны программ",
		"courseTemplates": "Каталог курсов",
		"myTemplates": "Мои шаблоны"
	},
	"create": {
		"path": {
			"title": "Как соберём курс?",
			"subtitle": "Три сценария. Свои материалы нужны только в последнем.",
			"empty": {
				"title": "Пустой",
				"desc": "Пространство для ваших материалов: файлы, лекции, веб-источники и репетитор по ним"
			},
			"topic": {
				"title": "По теме",
				"desc": "Назовите тему — соберём программу, проверим уровень и настроим под вас"
			},
			"catalog": {
				"title": "Из каталога",
				"desc": "Готовые программы: ЕГЭ, университетские курсы, языки"
			}
		},
		"empty": {
			"defaultTitle": "Новый курс",
			"creating": "Создаём курс — секунду"
		},
		"finder": {
			"title": "Что вы хотите изучить?",
			"subtitle": "Поищем готовое в каталоге. Не найдём — соберём свой курс по этой теме.",
			"placeholder": "Например: физика ЕГЭ",
			"idleTitle": "Назовите тему",
			"idleHint": "Начните вводить — покажем подходящие курсы каталога.",
			"offlineTitle": "Каталог доступен только онлайн",
			"offlineHint": "Поиск по каталогу идёт на сервер. Проверьте связь и попробуйте снова.",
			"errorTitle": "Не удалось найти курсы",
			"errorHint": "Каталог не ответил. Программа поиска не пострадала — попробуйте ещё раз.",
			"retry": "Попробовать ещё раз",
			"emptyTitle": "В каталоге такого пока нет",
			"emptyHint": "Соберём свой курс «{query}»? Программу построим по теме — материалы не нужны.",
			"buildOwn": "Собрать свой курс",
			"ownCourse": "Соберу свой курс по этой теме",
			"all": "Смотреть весь каталог",
			"starting": "Начинаем курс — секунду"
		},
		"brief": {
			"title": "Курс по теме",
			"subtitle": "Четыре коротких вопроса — и черновик программы готов.",
			"steps": {
				"topic": "Тема",
				"goal": "Цель",
				"level": "Уровень",
				"materials": "Материалы",
				"review": "Проверка"
			},
			"back": "Назад",
			"next": "Далее",
			"submit": "Собрать черновик программы",
			"topic": {
				"question": "Что вы хотите изучить?",
				"hint": "Это же станет названием курса — переименовать можно потом.",
				"placeholder": "Например: физика, 11 класс",
				"footnote": "Материалы не нужны: программу соберём по теме.",
				"matchTitle": "Похожее уже есть в библиотеке",
				"matchHint": "Готовую программу можно открыть и начать — введённое здесь сохранится.",
				"matchAll": "Показать все"
			},
			"goal": {
				"question": "Зачем вам это?",
				"hint": "Цель влияет на состав программы и на то, что подсказывает репетитор.",
				"placeholder": "Например: сдать ЕГЭ на 90+",
				"skip": "Пропустить — цель добавлю позже"
			},
			"level": {
				"question": "С чего начинаем?",
				"hint": "От уровня зависит, с какой глубины пойдут первые темы.",
				"options": {
					"beginner": "Начальный",
					"intermediate": "Средний",
					"advanced": "Продвинутый"
				},
				"unknown": {
					"title": "Не знаю — проверить тестом",
					"desc": "Соберём программу по среднему уровню и предложим короткий тест: он подтянет темы под вас"
				},
				"descriptions": {
					"beginner": "Тему вижу впервые — начнём с азов",
					"intermediate": "Основы знаю, нужен разбор и практика",
					"advanced": "База уверенная — интересны сложные случаи"
				},
				"audience": {
					"question": "Кому объясняем?",
					"hint": "От этого зависит язык курса: словарь, примеры и тон. На глубину не влияет.",
					"adult": "Взрослому",
					"options": {
						"3-7": "Ребёнку 3–7 лет",
						"7-11": "Ребёнку 7–11 лет",
						"11-14": "Подростку 11–14 лет",
						"14-17": "Подростку 14–17 лет"
					}
				}
			},
			"materials": {
				"question": "Есть свои конспекты или учебники?",
				"hint": "Программа их учтёт. Файлы попадут в библиотеку — курс подхватит их сам.",
				"library": "Из библиотеки",
				"libraryHide": "Свернуть библиотеку",
				"selected": "Выбрано: {count, plural, one {# материал} few {# материала} many {# материалов} other {# материала}}",
				"none": "У меня нет материалов — дальше"
			},
			"review": {
				"question": "Всё верно?",
				"hint": "Проверьте ответы — и собираем программу.",
				"topic": "Тема",
				"goal": "Цель",
				"level": "Уровень",
				"materials": "Материалы",
				"notSet": "Не указана",
				"noMaterials": "Без материалов",
				"cost": {
					"time": "около минуты",
					"generations": "1 генерация из дневного лимита"
				},
				"failed": "Не удалось собрать черновик программы",
				"failedGeneric": "Сборка не дошла до конца. Курс не создан — попробуйте ещё раз.",
				"retry": "Попробовать ещё раз"
			}
		}
	},
	"card": {
		"sourcesCount": "{count, plural, one {# источник} few {# источника} many {# источников} other {# источников}}",
		"topicsCount": "{count, plural, one {# тема} few {# темы} many {# тем} other {# тем}}",
		"progress": "{done} / {total}",
		"progressAria": "Пройдено {done} из {total} тем",
		"currentTopicEyebrow": "Текущая тема",
		"currentTopicLabel": "Тема {index} · {title}",
		"minutesShort": "~{count} мин",
		"continue": "Продолжить",
		"open": "Открыть курс",
		"emptyTitle": "Материалов пока нет",
		"emptyHint": "Добавь материалы — построим программу.",
		"emptyCta": "Добавить материалы",
		"building": "Строим программу…",
		"completed": "Курс пройден",
		"staleBadge": "Состав изменился",
		"actions": "Действия с курсом",
		"mastery": "Освоение",
		"masteryValue": "{pct}%"
	},
	"detail": {
		"back": "К курсам",
		"meta": "{sources} · {topics}",
		"examDate": "до {date}",
		"noExamDate": "Дата экзамена не задана",
		"emptyProgram": "Добавь материалы, чтобы построить программу",
		"emptyProgramHint": "Нужно несколько источников — программа строится по их содержанию.",
		"addSources": "Добавить материалы",
		"buildProgram": "Построить программу",
		"buildProgramStarted": "Строим программу — это займёт до минуты",
		"buildProgramError": "Не удалось запустить построение программы",
		"building": "Строим программу",
		"buildingHint": "AI читает источники и раскладывает темы. Страница обновится сама.",
		"sectionProgress": "{done}/{total}",
		"tabs": {
			"program": "Программа",
			"composition": "Состав",
			"about": "О курсе"
		},
		"stale": {
			"title": "Состав изменился",
			"added": "{count, plural, one {+# материал} few {+# материала} many {+# материалов} other {+# материалов}}",
			"cta": "Показать изменения"
		},
		"composition": {
			"title": "Состав",
			"hint": "Материалы и папки, по которым построена программа",
			"add": "Добавить",
			"remove": "Убрать из курса",
			"removed": "Убрано из курса",
			"removeError": "Не удалось убрать из курса",
			"added": "{count, plural, one {Добавлен # материал} few {Добавлено # материала} many {Добавлено # материалов} other {Добавлено # материалов}}",
			"addError": "Не удалось добавить в курс",
			"empty": "Здесь пока пусто",
			"folderItems": "{count, plural, one {# материал} few {# материала} many {# материалов} other {# материалов}}",
			"openFolder": "Открыть папку",
			"addTitle": "Добавить источники",
			"addDescription": "Выбери материалы или папки целиком — папка остаётся живой ссылкой.",
			"tabMaterials": "Материалы",
			"tabFolders": "Папки"
		},
		"courseWide": {
			"title": "Создать по всему курсу",
			"hint": "Итоговый тест, конспект и карточки — по всем источникам сразу",
			"finalQuiz": "Итоговый тест",
			"singleNote": "Единый конспект",
			"allFlashcards": "Все карточки",
			"glossary": "Глоссарий курса",
			"generate": "Создать",
			"open": "Открыть",
			"warnMany": "В курсе {count} источников — это дорогая генерация, займёт несколько минут."
		},
		"topicStatus": {
			"done": "Пройдена",
			"current": "Текущая",
			"pending": "Не начата",
			"generating": "Готовится"
		},
		"tooManyMaterials": "Источников очень много — программа может выйти грубой. Возможно, стоит разбить курс.",
		"belowThreshold": "Материала пока мало: {materials} из {materialsRequired} источников и {words} из {wordsRequired} слов.",
		"buildingSteps": {
			"read": "Читаем источники",
			"structure": "Раскладываем темы",
			"schedule": "Распределяем нагрузку"
		},
		"actions": {
			"rename": "Переименовать",
			"goalParams": "Цель и параметры",
			"renameTitle": "Переименовать курс",
			"renameSubmit": "Сохранить",
			"renamed": "Курс переименован",
			"renameError": "Не удалось переименовать курс",
			"pause": "Поставить на паузу",
			"paused": "Курс на паузе",
			"pauseError": "Не удалось поставить курс на паузу",
			"resume": "Продолжить курс",
			"resumed": "Курс возобновлён",
			"resumeError": "Не удалось возобновить курс",
			"archive": "В архив",
			"archived": "Курс в архиве",
			"archiveError": "Не удалось архивировать курс",
			"restore": "Вернуть из архива",
			"restored": "Курс возвращён из архива",
			"restoreError": "Не удалось вернуть курс из архива",
			"delete": "Удалить курс",
			"deleteConfirmTitle": "Удалить «{title}»?",
			"deleteConfirmDescription": "Программа, темы и прогресс будут удалены. Материалы останутся в библиотеке.",
			"deleted": "Курс удалён",
			"deleteError": "Не удалось удалить курс"
		},
		"nowStudying": "Текущая тема",
		"openTopicPage": "Открыть страницу темы"
	},
	"topic": {
		"back": "К курсу",
		"position": "Тема {index} из {total}",
		"minutesShort": "~{count} мин",
		"steps": {
			"step1": {
				"eyebrow": "Разобраться",
				"label": "Разобраться",
				"finishCta": "Понятно — открыть шаг 2",
				"finishHint": "Прочитайте или прослушайте материал. Или отметьте как выполненное, когда будете готовы — шаг 2 откроется автоматически."
			},
			"step2": {
				"eyebrow": "Проверить",
				"label": "Проверить",
				"locked": "Откроется после шага 1",
				"unlocked": "Шаг 2 открыт — проверьте свои знания"
			},
			"step3": {
				"eyebrow": "Добрать",
				"label": "Добрать",
				"locked": "Откроется после шагов 1 и 2"
			}
		},
		"route": {
			"aria": "Шаг {step} из 3: {label}",
			"stepAria": "Шаг {step}: {label}",
			"potentialHint": "Появится, если тест найдёт пробелы"
		},
		"channels": {
			"alsoAvailable": "также доступно",
			"note": {
				"title": "Прочитать конспект",
				"meta": "{minutes} мин · {terms, plural, one {# термин} few {# термина} many {# терминов} other {# терминов}}",
				"cta": "Читать",
				"pending": "Конспект готовится",
				"edit": "Правка"
			},
			"audio": {
				"title": "Послушать",
				"idle": "выбрать формат",
				"cta": "Выбрать",
				"generating": "Готовим озвучку",
				"generatingEta": "≈ {seconds} сек",
				"ready": "{format} · {duration}",
				"play": "Слушать",
				"offline": "офлайн",
				"offlineAria": "Доступно офлайн",
				"failed": "Не удалось создать аудио",
				"retry": "Повторить"
			},
			"flashcards": {
				"title": "Карточки",
				"meta": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточек}}",
				"cta": "Учить"
			},
			"quiz": {
				"title": "Тест",
				"meta": "{count, plural, one {# вопрос} few {# вопроса} many {# вопросов} other {# вопросов}}",
				"cta": "Пройти"
			},
			"voice": {
				"title": "Разобрать голосом",
				"meta": "~{minutes} мин",
				"cta": "Начать"
			},
			"chat": {
				"title": "Спросить в чате",
				"cta": "Спросить"
			}
		},
		"gaps": {
			"title": "{topic} — {errors, plural, one {# ошибка} few {# ошибки} many {# ошибок} other {# ошибок}} из {total}",
			"hint": "Разберём именно это, а не тему целиком.",
			"preparing": "Готовим разбор",
			"error": "Не удалось начать разбор",
			"chatPrompt": "Помоги разобраться с темой «{topic}». Сложности: {gaps}.",
			"slow": "Подготовка занимает больше времени, чем обычно — нажмите еще раз для повторной попытки",
			"retry": "Нажмите для повтора"
		},
		"allMaterials": "Все материалы темы",
		"allMaterialsHint": "Источники, глоссарий и всё, что создано по этой теме",
		"sources": "Источники",
		"glossary": "Глоссарий темы",
		"glossaryTerms": "{count, plural, one {# термин} few {# термина} many {# терминов} other {# терминов}}",
		"generateMore": "Сгенерировать ещё",
		"complete": "Завершить тему",
		"completeTooltip": "Можно завершить в любой момент",
		"completed": "Тема завершена",
		"completeError": "Не удалось завершить тему",
		"nextPreparing": "Тема {index} готовится",
		"nextReady": "Тема {index} готова",
		"generating": {
			"title": "Готовим тему",
			"hint": "Это меньше минуты. Можно уйти — пришлём уведомление.",
			"kinds": {
				"note": "Конспект",
				"glossary": "Глоссарий",
				"flashcards": "Карточки",
				"quiz": "Тест",
				"voicePlan": "План голосовой сессии"
			},
			"kindReady": "готово",
			"kindPending": "готовим",
			"kindQueued": "в очереди"
		},
		"prepare": "Подготовить тему",
		"prepareHint": "Материалы этой темы ещё не созданы — соберём конспект, карточки и тест.",
		"voicePlanSections": "{count, plural, one {# раздел} few {# раздела} many {# разделов} other {# разделов}}",
		"reader": {
			"back": "К маршруту темы"
		},
		"skipStepError": "Не удалось пропустить шаг"
	},
	"audioPicker": {
		"title": "Как озвучить тему?",
		"description": "Одно содержание, три способа послушать.",
		"formats": {
			"summary": {
				"title": "Резюме",
				"description": "Только тезисы",
				"voices": "1 голос"
			},
			"lecture": {
				"title": "Лекция",
				"description": "Плотно, академично",
				"voices": "1 голос"
			},
			"podcast": {
				"title": "Подкаст",
				"description": "Диалог двоих",
				"voices": "2 голоса"
			}
		},
		"durationMin": "до ~{minutes} мин",
		"submit": "Создать",
		"cancel": "Отмена",
		"started": "Аудио создаётся",
		"error": "Не удалось создать аудио",
		"quotaRecapDaily": "Дневной лимит аудио исчерпан — вернитесь завтра",
		"quotaTtsMinutes": "Дневной лимит минут озвучки исчерпан — вернитесь завтра",
		"quotaRefunded": "Квота возвращена",
		"errorReason": {
			"tier": "Аудиоконспекты доступны в тарифах Plus и Pro",
			"not-found": "Эта тема больше недоступна — перезагрузите страницу",
			"no-source": "Для озвучки нужен готовый материал — выберите обработанный источник или дождитесь обработки",
			"unknown": "Произошла ошибка. Попробуйте еще раз",
			"unavailable": "Аудиопересказы сейчас недоступны"
		}
	},
	"diff": {
		"title": "Курс обновится",
		"added": "Добавлено",
		"removed": "Удалено",
		"programChanges": "Что изменится в программе",
		"newTopics": "{count, plural, one {# новая тема в конец} few {# новые темы в конец} many {# новых тем в конец} other {# новых тем в конец}}",
		"reordered": "порядок тем {from}–{to}",
		"untouched": "{count, plural, =1 {тема 1 (пройдена) не затрагивается} other {темы 1–# (пройдено) не затрагиваются}}",
		"noChanges": "Программа остаётся прежней",
		"dismiss": "Не сейчас",
		"rebuild": "Перестроить непройденное",
		"addNew": "Добавить новые темы",
		"applied": "Программа обновляется",
		"error": "Не удалось обновить программу"
	},
	"errors": {
		"loadFailed": "Не удалось загрузить курс",
		"topicLoadFailed": "Не удалось загрузить тему",
		"kitFailed": "Не удалось подготовить материалы темы",
		"kitFailedHint": "Квота возвращена. Попробуй ещё раз.",
		"retry": "Повторить",
		"notFound": "Курс не найден",
		"topicNotFound": "Тема не найдена",
		"kitQuotaExceeded": "Лимит генераций на сегодня исчерпан",
		"kitQuotaExceededHint": "Материалы темы можно будет создать завтра или на другом тарифе.",
		"kitQuotaExceededHintNoSale": "Материалы по теме можно будет создать завтра."
	},
	"duplicate": {
		"action": "Копировать курс",
		"title": "Копирование курса",
		"subtitle": "Копия создаётся с нуля: прогресс и освоение не переносятся.",
		"nameLabel": "Название копии",
		"copyName": "{title} (копия)",
		"sources": "Источники",
		"sourcesHint": "Материалы и папки из состава курса",
		"program": "Программа",
		"programHint": "Разделы и темы, прогресс будет сброшен",
		"artifacts": "Созданные артефакты",
		"artifactsHint": "Заметки, карточки и тесты копируются — повторения и попытки начинаются заново",
		"artifactsNeedsProgram": "Доступно при копировании программы",
		"cancel": "Отмена",
		"submit": "Копировать",
		"success": "Курс скопирован",
		"open": "Открыть",
		"error": "Не удалось скопировать курс"
	},
	"rebuild": {
		"banner": {
			"title": "{count, plural, one {# материал ещё не добавлен в программу} few {# материала ещё не добавлены в программу} many {# материалов ещё не добавлены в программу} other {# материала ещё не добавлены в программу}}",
			"titleUnknown": "Новые материалы ещё не добавлены в программу",
			"hint": "Они уже доступны в чате с репетитором и в каждой новой генерации. Сама программа меняется только после обновления.",
			"update": "Обновить курс",
			"keep": "Оставить как есть",
			"kept": "Оставлено без изменений — программа не обновлена",
			"keepError": "Не удалось сохранить выбор"
		},
		"dialog": {
			"title": "Обновить курс",
			"description": "Выберите глубину обновления.",
			"soft": {
				"title": "Обновить неначатые темы",
				"recommended": "Рекомендуется",
				"hint": "Неначатые темы будут пересобраны из обновленных источников. Завершенные и текущие темы останутся без изменений, поэтому прогресс, освоение и карточки сохранятся.",
				"action": "Обновить неначатые темы"
			},
			"hard": {
				"title": "Пересобрать с нуля",
				"hint": "Вся структура будет создана заново на основе текущих источников. Прогресс курса сбросится: завершенные темы станут неначатыми, а их артефакты покинут программу, оставшись в вашей библиотеке. Это действие нельзя отменить.",
				"action": "Пересобрать с нуля",
				"confirm": "Пересобрать и сбросить прогресс"
			},
			"softStarted": "Обновление программы",
			"hardStarted": "Пересборка программы",
			"error": "Не удалось обновить программу"
		}
	},
	"sources": {
		"title": "Источники",
		"drop": {
			"title": "Перетащите файлы сюда",
			"choose": "Выберите файлы",
			"active": "Отпустите, чтобы добавить в курс",
			"hint": "PDF, DOCX, MD, аудио, ссылки — добавляются в курс автоматически"
		},
		"upload": "Загрузить",
		"fromLibrary": "Из библиотеки",
		"record": "Записать лекцию",
		"filesSection": "Файлы",
		"foldersSection": "Папки · активная ссылка",
		"liveLinkHint": "Папка остаётся связанной: все, что вы в неё добавите, также попадёт в курс",
		"rowMenu": "Действия с источником",
		"processing": "Обработка",
		"excluding": "Удаление из курса",
		"processingCount": "{count, plural, one {# источник ещё обрабатывается} few {# источника ещё обрабатываются} many {# источников ещё обрабатываются} other {# источника ещё обрабатываются}}",
		"openMaterial": "Открыть материал",
		"openFolder": "Открыть папку",
		"exclude": "Исключить из курса",
		"excludeHint": "«{name}» останется в вашей библиотеке — материал будет удалён только из этого курса.",
		"excluded": "Исключено из курса",
		"excludeFailed": "Не удалось исключить источник",
		"emptyTitle": "Источников пока нет",
		"emptyHint": "Добавьте файлы или папки — из них будет построена программа курса.",
		"attachFailed": "Загружено, но не добавлено в курс",
		"attachFailedHint": "Файлы находятся в вашей библиотеке — добавьте их через «Из библиотеки».",
		"windowDrop": {
			"title": "Отпустите файлы",
			"hint": "Они будут добавлены в курс и сразу начнут обрабатываться"
		},
		"discover": {
			"title": "Найти источники в вебе",
			"hint": "Ищем в открытом вебе, сами читаем страницы и показываем, чем каждая полезна.",
			"queryLabel": "Что искать",
			"queryPlaceholder": "Тема, вопрос или название экзамена",
			"search": "Найти",
			"searching": "Ищем…",
			"mode": {
				"label": "Режим поиска",
				"fast": "Быстрый",
				"deep": "Глубокий",
				"fastHint": "Один заход: 10-30 секунд, топ-10 страниц на выбор.",
				"deepHint": "Несколько раундов поиска и чтения: 1-3 минуты, на выходе отчёт со ссылками.",
				"deepLocked": "Глубокое исследование доступно на Plus и Pro. Нажмите, чтобы посмотреть тарифы.",
				"deepExhausted": "Глубокие исследования на этот месяц закончились. Нажмите, чтобы посмотреть тарифы.",
				"deepRemaining": "Осталось {remaining} из {limit} в этом месяце",
				"deepExhaustedNoSale": "Глубокие исследования на этот месяц закончились. Лимит обновится в начале следующего месяца."
			},
			"stage": {
				"planning": "Планирую запросы",
				"searching": "Ищу",
				"ranking": "Оцениваю",
				"reading": "Читаю источники",
				"readingCount": "Читаю источники ({done} из {total})",
				"reflecting": "Сверяю пробелы",
				"synthesizing": "Собираю отчёт",
				"importing": "Добавляю в курс",
				"round": "Раунд {round} из {total}"
			},
			"queriesLabel": "Как мы искали",
			"selectAll": "Выбрать все",
			"clearAll": "Снять выбор",
			"import": "Импортировать ({count})",
			"importing": "Импортируем…",
			"suggestionsLabel": "Наш поиск",
			"openOriginal": "Открыть оригинал",
			"deleteRun": "Убрать эти результаты",
			"runTitle": "Поиск: {query}",
			"resultsCount": "{count, plural, one {# источник} few {# источника} many {# источников} other {# источника}}",
			"type": {
				"official": "Официальный",
				"encyclopedia": "Энциклопедия",
				"article": "Статья",
				"video": "Видео",
				"academic": "Научная",
				"practice": "Практика",
				"other": "Прочее"
			},
			"empty": {
				"title": "Пока ничего не найдено",
				"hint": "Попробуйте назвать тему так, как она звучит в курсе."
			},
			"failed": {
				"title": "Поиск не удался",
				"noResults": "Ничего подходящего не нашлось. Попробуйте другую формулировку.",
				"aiUnavailable": "Поиск временно недоступен. Попробуйте через минуту.",
				"retry": "Повторить"
			},
			"imported": {
				"queued": "{count, plural, one {# источник добавляется} few {# источника добавляются} many {# источников добавляются} other {# источника добавляются}}",
				"duplicate": "{count, plural, one {# страница уже в курсе} few {# страницы уже в курсе} many {# страниц уже в курсе} other {# страницы уже в курсе}}",
				"limitReached": "Достигнут лимит веб-источников курса на вашем тарифе",
				"failed": "Импортировать не удалось"
			},
			"error": {
				"paywall": "Сайт за пейволом",
				"blocked": "Сайт запретил доступ — скопируйте текст вручную",
				"thin": "Слишком мало читаемого текста — страница может быть скриптовой оболочкой или заблокирована. Вставьте текст вручную или выберите другой источник",
				"robots": "Сайт запрещает автоматическое чтение",
				"unreachable": "Не удалось открыть сайт",
				"duplicate": "Уже в курсе",
				"limitReached": "Достигнут лимит тарифа",
				"noResults": "Ничего не найдено",
				"aiUnavailable": "Поиск недоступен"
			},
			"row": {
				"refetch": "Обновить из источника",
				"openOriginal": "Открыть оригинал",
				"refetchQueued": "Обновляем страницу…",
				"updatedAgo": "обновлено {days, plural, =0 {сегодня} one {# день назад} few {# дня назад} many {# дней назад} other {# дня назад}}",
				"neverFetched": "ещё не читали"
			},
			"importedBadge": "Импортировано в курс",
			"deepRunningHint": "Это займёт 1-3 минуты. Карточку можно свернуть — исследование продолжится.",
			"report": {
				"readyTitle": "Отчет сохранен",
				"readyHint": "{count, plural, =0 {Отчёт сохранён} one {Отчёт и # источник сохранены} few {Отчёт и # источника сохранены} many {Отчёт и # источников сохранены} other {Отчёт и # источников сохранены}}",
				"open": "Открыть отчёт",
				"sourcesLabel": "{count, plural, one {# источник отчёта} few {# источника отчёта} many {# источников отчёта} other {# источника отчёта}}",
				"pendingTitle": "Отчет готов",
				"pendingHint": "{count, plural, =0 {Выберите источники и сохраните, чтобы отчет остался} one {Выберите источники и сохраните — отчет будет сохранен с # источником} few {Выберите источники и сохраните — отчет будет сохранен с # источниками} many {Выберите источники и сохраните — отчет будет сохранен с # источниками} other {Выберите источники и сохраните — отчет будет сохранен с # источниками}}"
			},
			"importWithReport": "Сохранить отчет и {count, plural, one {# источник} few {# источника} many {# источников} other {# источника}}",
			"stop": "Остановить"
		}
	},
	"workspace": {
		"header": {
			"toggleLeft": "Панель курса",
			"calendar": "Календарь курса",
			"mastery": "Освоение",
			"masteryValue": "{pct}%",
			"masteryUnavailable": "Освоение ещё не рассчитано",
			"today": "Сегодня",
			"todayValue": "{done} / {goal} мин",
			"noProgram": "Программа ещё не построена",
			"aboutAria": "О программе"
		},
		"about": {
			"goal": "Цель:",
			"editGoal": "Изменить цель курса",
			"setGoal": "Задать цель курса"
		},
		"mobile": {
			"callBarAria": "Панели курса",
			"exit": "Назад к курсам",
			"routeAria": "Маршрут темы",
			"masteryValue": "{pct}%",
			"sheetHint": "Смахните вниз, чтобы закрыть",
			"calendar": "Календарь",
			"openPlan": "Открыть план курса",
			"placementAria": "Настройка курса"
		},
		"panel": {
			"aria": "Панель курса",
			"topics": "План",
			"topicsAria": "План курса",
			"sources": "Источники",
			"aboutMore": "ещё",
			"aboutLess": "свернуть",
			"created": "Артефакты",
			"createdAria": "Артефакты курса",
			"createdEmpty": "Курс пока ничего не создал"
		},
		"coverage": {
			"partial": "частичный охват",
			"partialHint": "Материал объёмный — сгенерировано по части источника.",
			"gapsHint": "Эти источники были в контексте генерации, но конспект их не процитировал.",
			"showSources": "Показать материалы",
			"gapsSummary": "{count, plural, one {# источник не процитирован} few {# источника не процитированы} many {# источников не процитированы} other {# источников не процитированы}}"
		},
		"discuss": {
			"topic": {
				"title": "Остались вопросы по теме?",
				"cta": "Обсудить с репетитором",
				"ctaPrompt": "У меня остались вопросы по теме «{topic}». Помоги разобраться",
				"ctaPromptNoTopic": "У меня остались вопросы по этой теме. Помоги разобраться"
			},
			"mistakes": {
				"title": "Разберём, что не получилось?",
				"cta": "Обсудить с репетитором",
				"ctaPrompt": "Контрольный тест по теме «{topic}» не сдан. Помоги разобрать ошибки",
				"ctaPromptNoTopic": "Контрольный тест не сдан. Помоги разобрать ошибки"
			},
			"chips": {
				"simpler": "Объясни проще главное из «{topic}»",
				"simplerNoTopic": "Объясни проще главное из этой темы",
				"examples": "Приведи ещё примеры по «{topic}»",
				"examplesNoTopic": "Приведи ещё примеры по этой теме",
				"mistakes": "Разбери мои ошибки: {gaps}"
			}
		},
		"right": {
			"tutor": "Репетитор"
		},
		"tutor": {
			"contextLabel": "Контекст",
			"chips": {
				"course": "Курс · {count, plural, one {# источник} few {# источника} many {# источников} other {# источника}}",
				"topic": "Тема {label} · Шаг {step}"
			},
			"openSources": "Источники курса",
			"openFullChat": "Открыть в полном чате",
			"newChatFailed": "Не удалось начать новый чат",
			"sessionFailed": "Не удалось открыть чат курса",
			"sessionErrorTitle": "Чат курса не открылся",
			"sessionErrorHint": "История сохранена — она осталась в общем списке чатов с репетитором.",
			"answerFailed": "Ответ не был получен",
			"streamBusy": "Дождитесь ответа, затем отправьте следующий",
			"offlineTitle": "Чат курса не в сети",
			"offlineHint": "Для работы репетитора требуется подключение. Предыдущие ответы откроются, как только чат загрузится.",
			"offlineComposer": "Офлайн — репетитор отвечает только онлайн",
			"contextDegraded": "Репетитор не получил текущую тему — ответ охватывает курс в целом",
			"unvisitedTopic": "Этот ответ опирается на тему {label} «{title}», которую вы ещё не проходили",
			"hints": {
				"explainSimpler": {
					"label": "Объяснить проще",
					"prompt": "Объясни тему «{topic}» проще, шаг за шагом."
				},
				"keyIdeas": {
					"label": "Ключевые идеи",
					"prompt": "Перечисли ключевые идеи темы «{topic}» кратким списком."
				},
				"examples": {
					"label": "Привести примеры",
					"prompt": "Приведи два-три конкретных примера для темы «{topic}»."
				},
				"checkMe": {
					"label": "Проверить меня",
					"prompt": "Задай мне три вопроса по теме «{topic}» и проверь мои ответы."
				},
				"whereStuck": {
					"label": "В чем я застрял",
					"prompt": "Я неверно ответил на тест по теме «{topic}». Покажи, что именно я не понял и как восполнить пробел."
				},
				"courseOverview": {
					"label": "О чем этот курс",
					"prompt": "Расскажи, чему посвящен курс «{course}», основываясь на моих источниках."
				},
				"whereToStart": {
					"label": "С чего начать",
					"prompt": "Подскажи, с чего начать изучение курса «{course}» и почему."
				}
			}
		},
		"placement": {
			"title": "Проверьте свой уровень",
			"hint": "Настроим темы под вас · около 10 минут",
			"start": "Пройти тест",
			"later": "Позже",
			"generating": "Составляем тест…",
			"generatingHint": "Вопросы собираются по программе курса — это займёт меньше минуты",
			"openTest": "Открыть тест",
			"retry": "Попробовать ещё раз",
			"failedTitle": "Не удалось составить входной тест",
			"failedHint": "Программа курса не пострадала. Можно повторить попытку или пройти диагностику позже.",
			"requestError": "Не удалось заказать входной тест",
			"skipError": "Не удалось отложить входной тест",
			"catalogTitle": "Проверим уровень — настроим курс под вас",
			"catalogHint": "Программу автора не меняем: тест покажет, что можно пройти быстрее, а где задержаться · около 10 минут",
			"promptTitle": "Уровень не определён",
			"outcomeTitle": "Курс настроен по входному тесту",
			"outcomeStrong": "{count, plural, one {# тему вы уже знаете} few {# темы вы уже знаете} many {# тем вы уже знаете} other {# тем вы уже знаете}}",
			"outcomeWeak": "{count, plural, =0 {всё остальное впереди} one {# тема требует внимания} few {# темы требуют внимания} many {# тем требуют внимания} other {# тем требуют внимания}}",
			"outcomeStartWeakest": "Начать с самой слабой темы",
			"outcomeStartFirst": "К первой теме",
			"strongHint": "По входному тесту вы уже знаете эту тему — замер {pct}%. Можно сразу к проверке.",
			"strongHintOther": "Замер показывает, что тему вы уже знаете — {pct}%. Можно сразу к проверке.",
			"strongCta": "К тесту",
			"skipNow": "Пропустить — начать сейчас",
			"startCourse": "Начать курс",
			"menuTake": "Входной тест",
			"menuRetake": "Пройти входной тест заново",
			"outcomeHint": "Программа адаптирована под ваши ответы: знакомые темы проходятся быстрее, а на пробелы выделяется больше времени.",
			"outcomeStrongLabel": "темы, которые вы уже знаете",
			"outcomeWeakLabel": "темы, требующие внимания",
			"outcomeDraftHint": "Отметили, что вы уже знаете, а чему стоит уделить больше внимания. Вы можете скорректировать программу и утвердить её.",
			"backToDraft": "Вернуться к программе"
		},
		"presets": {
			"quick": "5 минут",
			"quickHint": "Только карточки, требующие повторения",
			"commute": "В дороге",
			"commuteHint": "Аудиоканал темы",
			"deep": "Погружение",
			"deepHint": "Заметка и репетитор рядом"
		},
		"step": {
			"one": "Шаг 1 из 2 · Освоение",
			"twoCards": "Шаг 2 из 2 · Карточки",
			"twoQuiz": "Шаг 2 из 2 · Тест",
			"quizHint": "Ответьте на вопросы, чтобы продолжить",
			"three": "Шаг 3 из 3 · Работа над пробелами",
			"done": "Тема пройдена",
			"calendar": "Расписание курса",
			"tools": "Инструменты шага",
			"voice": "Голосовой урок с репетитором",
			"voiceHint": "Произнесите вслух — завершите урок, чтобы продолжить",
			"twoHub": "Шаг 2 из 2 · Проверьте себя",
			"character": "Повторение с персонажем",
			"characterHint": "Оставайтесь в курсе — вернитесь к пробелам после завершения",
			"checkpointHint": "Финальная проверка, и тема будет завершена",
			"checkpointPreparing": "Готовим контрольный тест…",
			"checkpointBelow": "Освоение {pct}% — рекомендуем добрать",
			"placement": "Настройка курса",
			"placementHint": "Пройдите тест или пропустите его, чтобы начать курс",
			"nextTopicBuilding": "Следующая тема еще готовится — она появится здесь"
		},
		"cta": {
			"finishStepOne": "Понятно — проверить себя",
			"toCheck": "К проверке",
			"toQuiz": "К тесту",
			"toGap": "Восполнить пробелы",
			"completeTopic": "Завершить тему",
			"nextTopic": "Следующая тема",
			"backToCourse": "Назад к курсам",
			"backToTopic": "Назад к теме",
			"continue": "Продолжить",
			"startCheckpoint": "Контрольный тест",
			"skipQuiz": "Пропустить тест",
			"skipCards": "Пропустить карточки",
			"skipCheckpoint": "Пропустить контрольный"
		},
		"footer": {
			"progressAria": "Прогресс темы"
		},
		"scene": {
			"note": {
				"eyebrow": "Шаг 1 · Освоение материала",
				"untitled": "Конспект темы",
				"minutesShort": "{count} мин",
				"channelAria": "Чтение или прослушивание",
				"channelRead": "Читать",
				"channelListen": "Слушать",
				"edit": "Редактировать",
				"done": "Готово",
				"backToTopicNote": "Назад к конспекту темы",
				"emptyTitle": "Для этой темы ещё нет конспекта",
				"emptyHint": "StudyHub анализирует источники темы и создает структурированное резюме — обычно меньше чем за минуту.",
				"emptyCta": "Создать конспект",
				"generatingTitle": "Создание конспекта",
				"generatingPercent": "{percent}%",
				"generatingStepRead": "Анализ источников",
				"generatingStepWrite": "Написание резюме",
				"generatingStepPolish": "Добавление акцентов и проверок",
				"failedTitle": "Не удалось создать конспект",
				"failedHint": "Ничего не потеряно — источники остались на месте. Попробуйте ещё раз.",
				"retry": "Попробовать снова",
				"quotaTitle": "Достигнут дневной лимит генерации",
				"quotaHint": "Конспект для этой темы будет доступен завтра или прямо сейчас при переходе на другой тариф.",
				"quotaCta": "Выбрать тариф",
				"aiNote": "Сгенерировано StudyHub на основе источников темы. Проверяйте цифры и даты.",
				"quotaHintNoSale": "Конспект по этой теме будет доступен завтра."
			},
			"audio": {
				"untitled": "Аудио темы",
				"pickTitle": "Как вы хотите слушать?",
				"pickHint": "Содержание остаётся прежним — меняется только формат подачи. Вы можете сменить его в любой момент.",
				"formatReady": "Готово",
				"formatReadyWithDuration": "Готово · {duration}",
				"formatPending": "Создаётся…",
				"formatCreate": "Создать · до ~{minutes} мин",
				"changeFormat": "Сменить формат",
				"download": "Скачать MP3",
				"downloadFailed": "Не удалось подготовить файл для скачивания",
				"share": "Поделиться",
				"askTutor": "Спросить репетитора",
				"askPrompt": "Давайте обсудим этот аудио-пересказ темы.",
				"offlineSave": "Сохранить для офлайна",
				"offlineReady": "Доступно офлайн",
				"offlineSaved": "Сохранено на устройстве — будет воспроизводиться без сети",
				"offlineFailed": "Не удалось сохранить файл на устройство",
				"generatingTitle": "Запись аудио",
				"generatingHint": "Вы можете покинуть этот экран — аудио доделается самостоятельно, и придет уведомление.",
				"failedTitle": "Не удалось создать аудио",
				"failedHint": "Ваша квота была возвращена. Выберите формат снова — или выберите более короткий.",
				"retry": "Попробовать снова",
				"offlineTranscriptTitle": "Для транскрипта нужно подключение",
				"offlineTranscriptCached": "Само аудио находится на устройстве и работает офлайн; текст транскрипта локально не хранится.",
				"offlineTranscriptNoFile": "Ни транскрипт, ни аудиофайл ещё не загружены на это устройство. Сохраните аудио для офлайна, пока вы в сети.",
				"createMore": "Создать ещё",
				"customize": "Настроить вручную",
				"customizeTitle": "Настройки аудио",
				"customizeHint": "Выберите формат, стиль, голоса и длительность, затем запустите генерацию для этой темы."
			},
			"common": {
				"retry": "Попробовать снова",
				"upgradeCta": "Тарифы"
			},
			"cards": {
				"generating": "Создание колоды",
				"emptyTitle": "Для этой темы ещё нет карточек",
				"emptyDescription": "StudyHub превращает источники темы в колоду — обычно менее чем за минуту.",
				"emptyCta": "Создать колоду",
				"failedTitle": "Не удалось создать колоду",
				"failedDescription": "Ничего не пропало — источники остались нетронутыми. Попробуйте снова.",
				"quotaTitle": "Достигнут дневной лимит генерации",
				"quotaDescription": "Колода для этой темы будет доступна завтра или прямо сейчас на более высоком тарифе.",
				"quotaDescriptionNoSale": "Колода по этой теме будет доступна завтра."
			},
			"quiz": {
				"generating": "Составление вопросов",
				"emptyTitle": "Для этой темы ещё нет теста",
				"emptyDescription": "StudyHub составляет вопросы на основе источников темы — обычно это занимает меньше минуты.",
				"emptyCta": "Составить тест",
				"failedTitle": "Не удалось составить тест",
				"failedDescription": "Ничего не потеряно — источники остались нетронутыми. Попробуйте ещё раз.",
				"quotaTitle": "Достигнут дневной лимит генерации",
				"quotaDescription": "Тест по этой теме будет доступен завтра или сразу при переходе на более высокий тариф.",
				"submittedTitle": "Тест отправлен",
				"submittedDescription": "Ответы подсчитаны, прогресс по теме обновлён. Полный разбор доступен на отдельном экране.",
				"openResults": "Открыть разбор",
				"retake": "Пройти ещё раз",
				"checkpointPassed": "Контрольный тест пройден — {pct}%. Тему можно завершать",
				"checkpointFailedTitle": "{pct}% — до подтверждения не хватило",
				"checkpointMisses": "Промахи: {gaps}",
				"checkpointCloseGaps": "Закрыть пробелы ещё раз",
				"quotaDescriptionNoSale": "Тест по этой теме будет доступен завтра."
			},
			"gap": {
				"eyebrow": "Шаг 3 · Устранение пробелов — добавлено после вашего теста",
				"heading": "{count, plural, one {Один пробел — около пяти минут на устранение} few {# пробела — устраним их по очереди} many {# пробелов — устраним их по очереди} other {# пробела — устраним их по очереди}}",
				"analyzing": "Анализируем ваши ответы",
				"noneTitle": "Пробелов нет",
				"noneDescription": "Тест не выявил слабых мест. Все темы усвоены — вы можете углубиться в материал или завершить изучение.",
				"title": "{count, plural, one {# пробел} few {# пробела} many {# пробелов} other {# пробела}}",
				"hint": "Мы проработаем именно это, а не всю тему заново.",
				"errors": "{errors, plural, one {# ошибка} few {# ошибки} many {# ошибок} other {# ошибки}} из {total} в этой подтеме",
				"mastery": "Освоение темы {pct}%",
				"srsQueued": "{count, plural, one {# карточка из этой темы уже} few {# карточки из этой темы уже} many {# карточек из этой темы уже} other {# карточки из этой темы уже}} запланирована к повторению",
				"routeToast": "Тест выявил пробел — в вашем маршруте появился шаг «Устранение пробелов»",
				"voiceTitle": "Голосовой репетитор",
				"voiceHint": "{minutes}-минутная сессия, направленная именно на этот пробел",
				"chatTitle": "Спросить в чате",
				"chatHint": "Репетитор уже знает эту тему",
				"rereadTitle": "Перечитать раздел",
				"rereadHint": "Открыть основную заметку по этой теме",
				"eyebrowDeepen": "Шаг 3 · Углубление",
				"headingNone": "Пробелов нет — вы можете углубить знания",
				"primaryTitle": "Способы закрыть пробелы",
				"moreTitle": "Дополнительные способы практики",
				"noteTitle": "Заметка с пропусками",
				"noteHint": "Краткая заметка о том, что вы упустили",
				"moreQuizTitle": "Еще один тест",
				"moreQuizHint": "Повторная проверка по тому же материалу",
				"checkpointTitle": "Контрольный тест",
				"checkpointHint": "Строгая проверка темы: порог 80%",
				"gapCardsTitle": "Флеш-карточки для пробелов",
				"gapCardsHint": "Карточки, созданные на основе ваших пробелов в знаниях",
				"charactersTitle": "Обсудите тему с персонажем",
				"charactersHint": "Разыграйте слабое место по ролям",
				"audioTitle": "Аудиоформат",
				"audioHint": "Прослушать тему еще раз",
				"mindmapTitle": "Интеллект-карта",
				"mindmapHint": "Визуализируйте структуру темы",
				"infographicTitle": "Инфографика",
				"infographicHint": "Одно изображение, охватывающее тему",
				"summaryTitle": "Краткая сводка",
				"summaryHint": "Кратчайшее резюме темы",
				"recommendedTitle": "Рекомендуемые способы устранения пробелов",
				"gapNotePrompt": "Составьте краткий учебный конспект по теме «{topic}», сфокусированный только на следующих пробелах: {gaps}. Структурируйте его так, чтобы его можно было сохранить как артефакт заметки.",
				"gapNotePromptDeepen": "Напишите краткий учебный конспект, раскрывающий тему «{topic}». Структурируйте его так, чтобы его можно было сохранить как отдельный объект-заметку.",
				"chatPromptDeepen": "Помоги мне глубже изучить тему «{topic}». На чем мне стоит сосредоточиться дальше?",
				"mindmapPrompt": "Создай {type} по теме «{topic}», сфокусировавшись на следующих пробелах: {gaps}. Сначала размести диаграмму, затем добавь два предложения с пояснениями.",
				"headingLowMastery": "Уровень освоения темы — {pct}%: продолжайте практику",
				"lowMasteryTitle": "Усвоение темы {pct}%",
				"lowMasteryDescription": "Тест не выявил слабых мест, однако уровень усвоения темы ниже 80%. Используйте инструменты ниже для дополнительного изучения.",
				"lowMasteryHint": "Используйте инструменты ниже для практики, затем завершите тему, когда будете готовы.",
				"recommendedDeepenTitle": "Способы повышения уровня знаний",
				"progress": "Пройдено {pct}%"
			},
			"done": {
				"chip": "Тема завершена",
				"title": "Тема завершена",
				"summary": "Пройдено — {topicPct}%. Освоение — {coursePct}%.",
				"summaryTopicOnly": "Пройдено — {topicPct}%.",
				"statTerms": "Изучено понятий",
				"statSrs": "Снова в повторении",
				"statTime": "Время на тему",
				"statTimeValue": "~{count} мин",
				"statTimeHint": "Плановое время на эту тему — StudyHub не использует секундомер.",
				"nextTitle": {
					"ready": "Тема {index} готова",
					"preparing": "Тема {index} готовится",
					"not-started": "Дальше — тема {index}"
				},
				"lastTitle": "Это была последняя тема",
				"lastHint": "Основная часть курса завершена. Материалы остаются доступными.",
				"remedialTitle": "В разделе «{section}» остались пробелы",
				"remedialHint": "Слабый результат по темам: {topics}. Добавить тему-закрепление, которая разберёт именно их?",
				"remedialAdd": "Добавить тему",
				"remedialLater": "Не сейчас",
				"remedialError": "Не удалось добавить тему-закрепление. Попробуйте ещё раз.",
				"nextHint": {
					"ready": "Создана, пока вы работали над предыдущей",
					"preparing": "Ещё создаётся — будет готова к вашему возвращению",
					"not-started": "Соберём материалы, когда вы её откроете — это меньше минуты"
				}
			},
			"calendar": {
				"srsNote": "Интервальные повторения общие для всех ваших курсов, поэтому здесь они не отображаются.",
				"srsLink": "Открыть календарь обучения",
				"inactive": {
					"paused": {
						"title": "Курс приостановлен",
						"description": "Пока курс приостановлен, планировщик не составляет для него занятия. Возобновите курс, и расписание вернётся — ничего не будет потеряно."
					},
					"archived": {
						"title": "Курс в архиве",
						"description": "Архивные курсы исключены из расписания. Восстановите курс, чтобы вернуть его занятия в календарь."
					},
					"completed": {
						"title": "Курс завершён",
						"description": "Больше нечего планировать — все темы пройдены. Материалы и повторения остаются доступными."
					}
				}
			},
			"voice": {
				"emptyTitle": "Голосовой урок по этой теме",
				"emptyDescription": "Репетитор задает вопросы вслух и следует плану занятия по этой теме. Запись голоса не ведется — сохраняется только текстовая расшифровка.",
				"startTitle": "Начать урок",
				"startHint": "Около {minutes} мин, голос, прямо внутри курса"
			},
			"step1": {
				"heading": "Выберите способ изучения этой темы",
				"noteTitle": "Прочитать",
				"noteHint": "Структурированное резюме источников по теме",
				"audioTitle": "Прослушать",
				"audioHint": "Подкаст, лекция или краткий пересказ",
				"alsoAvailable": "Также доступно",
				"statusDone": "Готово",
				"ctaRead": "Читать",
				"ctaListen": "Слушать",
				"ctaReread": "Перечитать",
				"ctaRelisten": "Слушать",
				"extrasTitle": "Ваши генерации",
				"extraNoteTitle": "Дополнительный конспект",
				"extraNoteHint": "Сгенерировано для пробелов или по запросу",
				"extraUserNoteHint": "Ваша собственная заметка по теме"
			},
			"step2": {
				"heading": "Проверьте свои знания по этой теме",
				"cardsTitle": "Карточки",
				"cardsHint": "Вспомните ключевые идеи",
				"quizTitle": "Тест",
				"quizHint": "Краткая проверка с оценкой уверенности",
				"statusDone": "Готово",
				"ctaStart": "Начать",
				"ctaContinue": "Продолжить",
				"ctaRetry": "Повторить",
				"ctaResults": "Результаты",
				"extrasTitle": "Ваши генерации",
				"extraCardsTitle": "Дополнительные карточки",
				"extraCardsHint": "Сгенерировано для пробелов или по запросу",
				"extraQuizTitle": "Дополнительные тесты",
				"extraQuizHint": "Сгенерировано для пробелов или по запросу",
				"cardsMissing": "В этой теме нет карточек"
			},
			"character": {
				"emptyTitle": "Чат с персонажем по этой теме",
				"emptyDescription": "Выберите персонажа на панели инструментов или на этапе заполнения пропусков — диалог останется в рамках курса и будет использовать материалы этой темы."
			},
			"placement": {
				"title": "Настройка курса",
				"hint": "Короткий тест (~10 мин) покажет, что вы уже знаете и на чем стоит остановиться подробнее.",
				"failedTitle": "Не удалось сформировать входной тест",
				"failedHint": "Программа курса не изменилась. Повторите попытку или пропустите тест и начните курс.",
				"retake": "Пройти тест заново"
			}
		},
		"topicBar": {
			"back": "Назад",
			"noTopic": "Тема не выбрана",
			"position": "Тема {index} из {total}",
			"views": {
				"noteEditor": "Правка конспекта",
				"cards": "Карточки",
				"quiz": "Тест",
				"gap": "Пробелы",
				"done": "Тема пройдена",
				"calendar": "Расписание",
				"tools": "Инструменты",
				"builder": "Структура",
				"note": "Читать",
				"audio": "Слушать",
				"voice": "Голосовой урок",
				"step1": "Понимание",
				"step2": "Проверка знаний",
				"character": "Персонаж",
				"placement": "Настройка курса"
			}
		},
		"journey": {
			"sectionLabel": "Модуль {index} · {title}",
			"topicDone": "пройдена",
			"topicDoneMastery": "пройдена · освоение {pct}%",
			"topicCurrent": "сейчас · {count} мин",
			"topicGenerating": "комплект готовится · будет готов к вашему приходу",
			"emptyTitle": "Программа еще не создана",
			"emptyHint": "Добавьте материалы и сформируйте курс — темы появятся здесь в порядке их изучения.",
			"masteryWeakBadge": "{pct}%",
			"masteryWeakHint": "Завершена с пробелами · замер {pct}%",
			"masteryStrongBadge": "Знаете",
			"masteryStrongHint": "По входному тесту вы уже знаете эту тему · замер {pct}%",
			"placementTitle": "Настройка курса",
			"placementCaption": "Проверим ваш уровень",
			"topicLocked": "Сначала завершите настройку курса"
		},
		"skip": {
			"flashcards": {
				"title": "Пропустить карточки?",
				"description": "Карточки закроются без повторения — термины этой темы не попадут в план повторов. Сразу перейдём к тесту; вернуться к карточкам можно из панели темы.",
				"confirm": "Пропустить"
			},
			"quiz": {
				"title": "Пропустить тест?",
				"description": "Шаг «Проверить» закроется без результата: пробелы по этой теме останутся неизвестными, а освоение — неподтверждённым. Тест можно пройти позже из панели темы.",
				"confirm": "Пропустить"
			},
			"checkpoint": {
				"title": "Пропустить контрольный тест?",
				"description": "Тема будет закрыта без итоговой проверки, поэтому уровень освоения останется неподтвержденным. Вы сможете запросить итоговый тест позже на этапе «Устранение пробелов».",
				"confirm": "Пропустить и завершить"
			}
		}
	},
	"tools": {
		"busy": "Обработка…",
		"quotaCta": "Посмотреть тарифы",
		"sceneTitle": "Инструменты по теме",
		"sceneHint": "Форматы, которые помогут разобраться с этой темой и проверить себя.",
		"items": {
			"audio": {
				"title": "Аудиоформат",
				"hint": "Подкаст, лекция или краткий пересказ"
			},
			"glossary": {
				"title": "Глоссарий темы",
				"hint": "Ключевые термины с определениями"
			},
			"userNote": {
				"title": "Ваша заметка",
				"hint": "Пустая заметка, открывающаяся в редакторе"
			},
			"tutor": {
				"title": "Спросить репетитора",
				"hint": "Чат, который уже знает эту тему"
			},
			"calendar": {
				"title": "Календарь курса",
				"hint": "Расписание по дням"
			},
			"moreCards": {
				"title": "Больше карточек",
				"hint": "Пересобрать колоду с расширенным набором"
			},
			"moreQuiz": {
				"title": "Ещё один тест",
				"hint": "Новые вопросы по той же теме"
			},
			"voice": {
				"title": "Голосовой репетитор",
				"hint": "Произнесите вслух — сессия откроется на весь экран"
			},
			"gapCards": {
				"title": "Карточки по пробелам",
				"hint": "Созданы на основе того, что выявил тест"
			},
			"reread": {
				"title": "Перечитать заметку",
				"hint": "Вернуться к тексту этой темы"
			},
			"mindmap": {
				"title": "Интеллект-карта",
				"hint": "Схема этой темы прямо в чат"
			},
			"infographic": {
				"title": "Инфографика",
				"hint": "Вся тема на одном изображении прямо в чате"
			},
			"summary": {
				"title": "Краткий обзор",
				"hint": "Краткая версия прямо в чате"
			},
			"characters": {
				"title": "Разобрать с персонажем",
				"hint": "Диалог по материалам темы — персонаж отвечает и ссылается на источники"
			}
		},
		"userNote": {
			"failed": "Не удалось создать заметку"
		},
		"voice": {
			"planPreparing": "Подготовка плана урока — плитка обновится, когда всё будет готово",
			"failed": "Не удалось запустить голосовую сессию",
			"alreadyActive": "Голосовая сессия уже запущена",
			"continueActive": "Продолжить"
		},
		"artifacts": {
			"title": "Артефакты",
			"hint": "Всё, что создано для этого курса",
			"topicSection": "Эта тема",
			"courseSection": "Весь курс",
			"menu": "Действия со строкой",
			"busy": "Выполняется…",
			"open": "Открыть",
			"exclude": "Исключить из курса",
			"excludeHint": "«{title}» будет удалён из курса, но останется в вашей библиотеке.",
			"excluded": "Исключено из курса",
			"excludeFailed": "Не удалось исключить",
			"regenerate": "Пересоздать",
			"retryRow": "Попробовать снова",
			"regenerateStarted": "Пересоздание — данные обновятся автоматически",
			"emptyTitle": "Здесь пока пусто",
			"emptyHint": "Сформируйте набор материалов — заметка, карточки и тест появятся здесь.",
			"emptyAction": "Сформировать набор",
			"errorTitle": "Не удалось прочитать артефакты",
			"errorHint": "Локальная копия не открылась. Попробуйте снова.",
			"retry": "Повторить",
			"kinds": {
				"note": "Заметка",
				"flashcards": "Карточки",
				"quiz": "Тест",
				"audio-recap": "Аудио",
				"glossary": "Глоссарий",
				"source": "Источник",
				"diagram": "Диаграмма",
				"infographic": "Инфографика",
				"saved-answer": "Сохранённый ответ"
			},
			"state": {
				"generating": "Генерация… {percent}%",
				"ready": "Готово",
				"readyIn": "Готово · {topic}",
				"failed": "Не удалось создать",
				"unconfirmed": "Не удалось подтвердить — обновите страницу"
			},
			"meta": {
				"cards": "{count, plural, one {# карточка} few {# карточки} many {# карточек} other {# карточки}}",
				"questions": "{count, plural, one {# вопрос} few {# вопроса} many {# вопросов} other {# вопроса}}",
				"terms": "{count, plural, one {# термин} few {# термина} many {# терминов} other {# термина}}",
				"minutes": "{count, plural, one {# мин} few {# мин} many {# мин} other {# мин}}",
				"text": "Текст",
				"own": "Ваша заметка",
				"srs": "SRS",
				"dialogue": "Диалог, {count} участников",
				"narration": "Озвучка",
				"savedAnswer": "Сохранённый ответ",
				"diagram": "Диаграмма",
				"infographic": "Инфографика"
			},
			"download": "Скачать",
			"downloadFailed": "Не удалось скачать файл",
			"delete": "Удалить",
			"deleteHint": "«{title}» перемещено в корзину.",
			"deleteFailed": "Не удалось удалить",
			"convertToSource": "Сделать источником",
			"dismiss": "Скрыть"
		},
		"offlineHint": "Требуется подключение к интернету",
		"mindmap": {
			"picker": {
				"title": "Выберите диаграмму",
				"description": "Репетитор построит её на основе этой темы. Превью показывают, как именно будет выглядеть результат.",
				"submit": "Построить"
			},
			"types": {
				"mindmap": {
					"title": "Интеллект-карта",
					"hint": "Идеи, исходящие из одной концепции"
				},
				"flowchart": {
					"title": "Блок-схема",
					"hint": "Шаги, условия и ветвления процесса"
				},
				"sequenceDiagram": {
					"title": "Последовательность",
					"hint": "Кто, что и кому отправляет по порядку"
				},
				"stateDiagram-v2": {
					"title": "Состояния",
					"hint": "Состояния объекта и переходы между ними"
				},
				"classDiagram": {
					"title": "Классы",
					"hint": "Сущности, их поля и связи"
				},
				"erDiagram": {
					"title": "ER-диаграмма",
					"hint": "Таблицы и связи между ними"
				},
				"timeline": {
					"title": "Таймлайн",
					"hint": "События, расположенные по датам"
				},
				"gantt": {
					"title": "Диаграмма Ганта",
					"hint": "Этапы и сроки проекта"
				}
			},
			"chatPrompt": "Нарисуй {type} для темы «{topic}». Сначала диаграмму, затем два предложения комментария.",
			"failed": "Репетитор ответил без диаграммы. Попробуйте снова или выберите другой формат."
		},
		"infographic": {
			"dialog": {
				"title": "Настройки инфографики",
				"description": "Репетитор проанализирует тему и создаст визуализацию.",
				"submit": "Создать",
				"busy": "Обработка…"
			},
			"fields": {
				"language": "Язык",
				"orientation": "Ориентация",
				"style": "Визуальный стиль",
				"detail": "Уровень детализации",
				"freeText": "На чем сделать акцент",
				"freeTextPlaceholder": "Формулы, даты, сравнения — что угодно, что нужно выделить"
			},
			"orientations": {
				"landscape": "Альбомная",
				"portrait": "Книжная",
				"square": "Квадратная"
			},
			"details": {
				"brief": "Кратко",
				"standard": "Стандартно",
				"detailed": "Подробно"
			},
			"styles": {
				"auto": {
					"title": "Авто",
					"hint": "Модель подберет стиль под контент"
				},
				"flat-vector": {
					"title": "Плоский вектор",
					"hint": "Сплошная заливка, округлые формы, спокойная палитра"
				},
				"editorial": {
					"title": "Редакционный",
					"hint": "Журнальная верстка, выразительный шрифт, много воздуха"
				},
				"blueprint": {
					"title": "Чертеж",
					"hint": "Темно-синий фон, тонкие белые линии, сетка"
				},
				"notebook": {
					"title": "Тетрадь",
					"hint": "Линованная бумага, штрихи маркером, рукописный текст"
				},
				"isometric": {
					"title": "Изометрия",
					"hint": "3D-блоки под углом, мягкие пастельные тени"
				},
				"chalkboard": {
					"title": "Меловая доска",
					"hint": "Темный фон, эффект мела, акцентные цвета"
				},
				"mono-minimal": {
					"title": "Моно-минимализм",
					"hint": "Чёрное на светлом, иерархия только за счёт начертания"
				}
			},
			"sources": {
				"count": "{count, plural, one {# источник из этой темы} few {# источника из этой темы} many {# источников из этой темы} other {# источника из этой темы}}",
				"empty": "Материалов пока нет — инфографика будет создана на основе названия темы"
			},
			"chatPrompt": "Создай инфографику по теме «{topic}».",
			"failed": "Не удалось запустить создание инфографики"
		},
		"summary": {
			"chatPrompt": "Дай краткую выжимку по теме «{topic}»: основные тезисы и то, что стоит запомнить."
		},
		"topicTitle": "Инструменты по теме",
		"courseWideCta": "Создать по всему курсу",
		"channels": {
			"read": "Читать",
			"watch": "Смотреть",
			"listen": "Слушать",
			"practice": "Практиковаться",
			"plan": "Планировать"
		}
	},
	"newCourse": {
		"empty": {
			"title": "Пространство для ваших материалов",
			"subtitle": "Загрузите то, что изучаете: заметки, PDF, слайды, записи лекций, ссылки и видео. Спрашивайте репетитора по своим источникам и ищите недостающее в вебе. Когда захотите — StudyHub соберёт из этого программу по темам."
		},
		"topicBridge": {
			"label": "Собрать программу по теме — материалы не нужны"
		},
		"upload": {
			"aria": "Как добавить материал",
			"tabs": {
				"file": "Файл",
				"link": "Ссылка",
				"text": "Текст",
				"web": "Веб"
			},
			"file": {
				"title": "Перетащите файлы сюда или нажмите для выбора",
				"titleMobile": "Выберите файлы для загрузки",
				"formats": "PDF · Word · Excel · PowerPoint · Текст · Markdown · изображения · аудио · видео",
				"max": "До {limit} файлов за раз"
			},
			"link": {
				"title": "Ссылка на страницу или видео",
				"hint": "Статьи, документация, YouTube и подкасты с транскрипцией.",
				"cta": "Добавить ссылку"
			},
			"text": {
				"title": "Ваш текст",
				"hint": "Конспект с лекции, глава, любой ваш текст.",
				"cta": "Добавить текст"
			},
			"fromLibrary": "Из библиотеки",
			"record": "Записать лекцию"
		},
		"tips": {
			"howMany": {
				"title": "Сколько материалов брать",
				"body": "Одного файла хватит, чтобы начать. Чем полнее набор, тем сильнее программа опирается на ваши материалы: ориентир — {materials} источника или один большой, от {words} слов. Это мера качества, а не пропуск: программу можно собрать и по одной теме, без файлов."
			},
			"folder": {
				"title": "Папка — это живая ссылка",
				"body": "Прикрепите папку из библиотеки: если позже добавить в неё файл, курс заметит это и предложит обновить программу."
			}
		},
		"sources": {
			"title": "Материалы курса"
		},
		"next": {
			"title": "Что дальше",
			"hint": "Сгенерировать программу автоматически или составить самостоятельно",
			"hintProcessing": "Дождитесь окончания индексации — это займёт несколько секунд",
			"hintNoSources": "Сначала добавьте хотя бы один источник",
			"callout": "Материалы можно добавить и позже — курс предложит обновить только те темы, к которым вы ещё не приступили, не сбрасывая освоение.",
			"belowRecommended": "Для генерации требуется {materials} источников или около {words} слов в сумме. При меньшем объеме процесс не начнется — добавьте больше материалов в любое время.",
			"hintFailed": "Ошибка обработки файла — замените его или добавьте другой источник",
			"or": "Или"
		},
		"generate": {
			"title": "Сгенерировать курс",
			"body": "StudyHub изучит источники, выделит темы и сгруппирует их в модули. Комплект для первой темы будет готов сразу.",
			"bullet1": "Программа по темам — до {topics} тем, с оценкой времени",
			"bullet2": "Конспект, карточки и тест для первой темы",
			"bullet3": "Порядок и названия можно редактировать позже",
			"cta": "Сгенерировать курс",
			"cost": "Занимает около минуты · 1 генерация из вашей квоты"
		},
		"manual": {
			"title": "Составить самостоятельно",
			"body": "Вы сами задаете модули и темы, прикрепляя к ним материалы. Удобно, если программа уже известна — например, из учебного плана.",
			"bullet1": "Ваши модули, темы и порядок",
			"bullet2": "Материалы прикрепляются к темам вручную",
			"bullet3": "ИИ можно вызвать для отдельного модуля",
			"cta": "Открыть конструктор",
			"cost": "Генерации не расходуются"
		},
		"params": {
			"title": "Параметры генерации",
			"subtitle": "Три подсказки для генератора и факты, на которых он будет строить программу.",
			"locale": "Язык программы",
			"sources": "Источники",
			"sourcesValue": "{ready} из {total} готовы",
			"maxTopics": "Максимум тем",
			"threshold": "Минимум для сборки",
			"thresholdValue": "{materials} источника или {words} слов",
			"level": {
				"label": "Уровень",
				"hint": "Для кого этот курс. Определяет глубину объяснений и темп.",
				"beginner": "Начальный",
				"intermediate": "Средний",
				"advanced": "Продвинутый"
			},
			"depth": {
				"label": "Глубина программы",
				"hint": "Рассчитано примерно на {weeks} недель обучения — чем глубже программа, тем подробнее прорабатывается каждый источник.",
				"quick": "Быстрая",
				"standard": "Стандартная",
				"deep": "Глубокая"
			},
			"focus": {
				"label": "Фокус курса",
				"placeholder": "Акцент на решении задач, главы 3-5 для экзамена…",
				"hint": "Необязательно. Направляет структуру и определяет, какие части источников будут использованы."
			},
			"editableLater": "Всё можно отредактировать позже: переименовать темы, изменить их порядок, пересобрать программу.",
			"close": "Отмена",
			"goal": {
				"title": "Цель курса",
				"subtitle": "К чему готовимся и в каком режиме. Программу не пересобирает.",
				"label": "Цель",
				"placeholder": "Например: сдать ЕГЭ на 80+ баллов",
				"hint": "Необязательно. Курс держит цель в уме: она попадает в промпт комплекта темы и в контекст репетитора.",
				"notDeclared": "Цель ещё не заявлена — значения ниже подставлены по умолчанию.",
				"noRebuild": "Сохранение меняет только цель. Уже собранная программа остаётся на месте.",
				"save": "Сохранить",
				"saved": "Цель курса сохранена",
				"saveError": "Не удалось сохранить цель курса"
			}
		},
		"generating": {
			"tips": {
				"one": "Тест сразу после объяснения эффективнее, чем в конце модуля — припоминание закрепляет знания лучше, чем повторное чтение.",
				"two": "Материалы для следующей темы готовятся, пока вы изучаете текущую, поэтому ждать не придётся.",
				"three": "Заметка и аудио содержат одну и ту же информацию: это выбор формата, а не два последовательных шага."
			}
		}
	},
	"builder": {
		"title": "Конструктор курса",
		"entry": "Редактировать структуру",
		"hint": "Добавляйте модули и темы, затем прикрепляйте источники к каждой теме. Набор — заметка, карточки, тест — генерируется, когда вы переходите к теме.",
		"suggestOutline": "Предложить структуру",
		"addModule": "Добавить модуль",
		"done": "Готово",
		"empty": {
			"title": "Модулей пока нет",
			"description": "Соберите программу вручную или позвольте ИИ предложить структуру на основе ваших источников."
		},
		"module": {
			"newTitle": "Модуль {index}",
			"placeholder": "Название модуля",
			"titleAria": "Название модуля",
			"drag": "Переместить модуль",
			"moveUp": "Переместить модуль выше",
			"moveDown": "Переместить модуль ниже",
			"delete": "Удалить модуль",
			"confirmDelete": "Удалить «{title}»?",
			"confirmDeleteHint": "{count, plural, =0 {Модуль пуст.} one {Будет удалена # тема и прогресс по ней.} few {Будет удалено # темы и прогресс по ним.} many {Будет удалено # тем и прогресс по ним.} other {Будет удалено # тем и прогресс по ним.}} Материалы останутся в вашей библиотеке.",
			"suggestTopics": "Темы модуля",
			"addTopic": "Добавить тему",
			"noTopics": "В этом модуле пока нет тем."
		},
		"topic": {
			"newTitle": "Новая тема",
			"placeholder": "Название темы — например, «Документы: DS-2019 и SEVIS»",
			"titleAria": "Название темы",
			"drag": "Переместить тему",
			"moveUp": "Переместить тему выше",
			"moveDown": "Переместить тему ниже",
			"delete": "Удалить тему",
			"confirmDelete": "Удалить «{title}»?",
			"confirmDeleteHint": "Тема и прогресс по ней будут удалены. Заметки, карточки и тесты останутся в вашей библиотеке.",
			"attach": "Прикрепить",
			"detach": "Открепить",
			"sourceDeleted": "Источник удалён",
			"moveToModule": "Переместить в другой модуль",
			"describe": "Описание темы",
			"descriptionHint": "Краткое описание помогает подобрать подходящие источники для этой темы и формирует структуру создаваемых материалов.",
			"descriptionPlaceholder": "О чём эта тема — в одном-двух предложениях"
		},
		"attach": {
			"title": "Прикрепить к теме",
			"description": "«{topic}» будет сформирована на основе выбранных здесь материалов.",
			"tabsAria": "Что прикрепить",
			"tabSources": "Источники",
			"tabArtifacts": "Артефакты",
			"cancel": "Отмена",
			"submit": "{count, plural, =0 {Прикрепить} one {Прикрепить #} few {Прикрепить #} many {Прикрепить #} other {Прикрепить #}}",
			"already": "прикреплено",
			"done": "{count, plural, =0 {Ничего нового не прикреплено} one {# элемент прикреплен} few {# элемента прикреплено} many {# элементов прикреплено} other {# элементов прикреплено}}",
			"emptySources": "В курсе нет источников",
			"emptySourcesHint": "Добавьте файлы на вкладке «Источники» — тогда вы сможете привязать тему к некоторым из них.",
			"emptyArtifacts": "Артефактов пока нет",
			"emptyArtifactsHint": "Здесь появятся заметки, карточки, тесты и аудио, которые у вас уже есть.",
			"kind": {
				"note": "Заметка",
				"flashcards": "Карточки",
				"quiz": "Тест",
				"audio": "Аудио"
			}
		},
		"draft": {
			"title": "Предлагаемая структура",
			"description": "Ничего ещё не создано. Снимите флажки с ненужных элементов и примените изменения.",
			"descriptionSection": "Темы, предложенные для «{module}». Пока ничего не создано.",
			"summary": "{count, plural, =0 {Ничего не выбрано} one {# тема будет создана} few {# темы будут созданы} many {# тем будет создано} other {# темы будет создано}}",
			"applying": "Создание {done} из {total}…",
			"applied": "{count, plural, one {# тема создана} few {# темы созданы} many {# тем создано} other {# темы создано}}",
			"applyFailed": "Остановлено после {count, plural, =0 {создания тем} one {# темы} few {# тем} many {# тем} other {# темы}} — попробуйте снова",
			"discard": "Отменить",
			"apply": "Применить"
		},
		"errors": {
			"failed": "Не удалось применить изменения",
			"noSources": "Добавьте хотя бы один источник — структура строится на их основе"
		}
	},
	"templates": {
		"publish": {
			"action": "Опубликовать как шаблон",
			"actionVersion": "Опубликовать версию {version}",
			"title": "Опубликовать курс в каталоге",
			"subtitle": "Три шага: подпись автора, описание для страницы курса, поля каталога.",
			"nameLabel": "Название шаблона",
			"categoryLabel": "Категория",
			"categoryPlaceholder": "Выберите категорию",
			"descriptionLabel": "Описание",
			"descriptionPlaceholder": "Что входит в курс и для кого он предназначен",
			"descriptionCounter": "{count} / {max}",
			"consentTitle": "Ваши файлы остаются закрытыми",
			"consentBody": "Ваши файлы остаются закрытыми, но их содержание становится доступным читателям через заметки и ответы репетитора. Читатели не видят список файлов и не могут ничего скачать.",
			"consentCheckbox": "Я понимаю это и хочу опубликовать",
			"cancel": "Отмена",
			"submit": "Опубликовать",
			"success": "Курс отправлен на модерацию",
			"error": "Не удалось опубликовать шаблон",
			"unpublishedBadge": "Неопубликованные изменения",
			"versionSuccess": "Версия {version} отправлена на проверку",
			"versionConfirmTitle": "Опубликовать версию {version}?",
			"versionConfirmBody": "Новые читатели начнут с этой версии. Те, кто уже проходит курс, останутся на своей версии, пока не решат обновиться. Новая версия повторно проходит проверку на соответствие правилам — курс будет скрыт из каталога до завершения проверки.",
			"versionConfirmCta": "Опубликовать",
			"back": "Назад",
			"next": "Далее",
			"steps": {
				"author": "Автор",
				"listing": "Описание",
				"publish": "Публикация"
			},
			"author": {
				"legend": "От чьего имени публикуется курс",
				"options": {
					"user": {
						"title": "От моего имени",
						"description": "В карточке курса будут видны ваше имя и аватар. Читатели смогут открыть другие ваши курсы."
					},
					"anonymous": {
						"title": "Анонимно",
						"description": "Курс публикуется без автора: ваше имя не появится на странице курса, в каталоге или в результатах поиска. Курс также не подписывается StudyHub — у него просто нет автора."
					}
				},
				"bioLabel": "Кратко о вас — необязательно",
				"bioPlaceholder": "Например: преподаватель биологии, девять лет готовлю к ЕГЭ",
				"bioHint": "Появится в блоке «Автор курса». Можно оставить пустым — тогда покажем только имя.",
				"linkLabel": "Ссылка на вас — необязательно",
				"linkPlaceholder": "Сайт, канал или профиль",
				"linkHint": "Одна ссылка рядом с вашим именем на странице курса.",
				"publicNotice": "Опубликованный курс доступен всем в интернете и попадает в поисковую выдачу. Снять его с витрины можно в любой момент — у тех, кто уже начал, курс останется.",
				"reviewNotice": "Перед появлением в каталоге курс проходит автоматическую проверку: никакого насилия, материалов для взрослых, оружия и других запрещенных тем. Обычно это занимает пару минут — до одобрения курс виден только вам."
			},
			"listing": {
				"generatingTitle": "Собираем описание курса",
				"generatingHint": "Можно не ждать на этом экране: описание догенерируется, даже если вы пойдёте дальше.",
				"steps": {
					"program": "Разбираем программу курса",
					"outcomes": "Формулируем, чему научится ученик",
					"audience": "Определяем аудиторию и уровень",
					"faq": "Готовим ответы на частые вопросы"
				},
				"readyNotice": "Описание составлено по программе курса. Проверьте формулировки — на странице курса будут именно они.",
				"readyNoticeBlind": "Описание составлено по программе курса. Заполненные здесь поля заменят сгенерированный текст, пустые останутся как есть.",
				"pendingHint": "Описание составим по программе курса сразу после публикации. Если заполните поля сами, возьмём ваш текст и генерировать не будем.",
				"failedHint": "Описание собрать не удалось. Публикацию это не блокирует: курс выйдет без витринных текстов, а описание можно составить позже.",
				"regenerate": "Сгенерировать заново",
				"aiChip": "составлено по курсу",
				"summaryLabel": "Краткое описание",
				"summaryPlaceholder": "О чём курс и что даёт",
				"summaryHint": "Видно в каталоге и в поисковой выдаче. Оптимально 120–160 символов.",
				"outcomesLabel": "Чему научится ученик",
				"outcomePlaceholder": "Например: решать задачи на скрещивание по алгоритму",
				"outcomeAria": "Результат {index}",
				"addOutcome": "Добавить пункт",
				"removeOutcome": "Удалить пункт",
				"audienceLabel": "Кому подойдёт",
				"audiencePlaceholder": "Кому этот курс полезен",
				"prerequisitesLabel": "Что нужно знать заранее",
				"prerequisitesPlaceholder": "Какая подготовка нужна на старте",
				"faqLabel": "Частые вопросы",
				"faqQuestionPlaceholder": "Вопрос",
				"faqQuestionAria": "Вопрос {index}",
				"faqAnswerPlaceholder": "Ответ",
				"faqAnswerAria": "Ответ на вопрос {index}",
				"addFaq": "Добавить вопрос",
				"removeFaq": "Удалить вопрос"
			},
			"publish": {
				"previewLabel": "Так курс будет выглядеть в каталоге",
				"previewUntitled": "Без названия",
				"freeNotice": "Курс будет опубликован бесплатным — его сможет пройти любой пользователь на любом тарифе."
			},
			"unpublishAction": "Снять с публикации",
			"relistAction": "Вернуть в каталог",
			"unpublishConfirmTitle": "Снять курс с публикации?",
			"unpublishConfirmBody": "Курс будет удален из каталога, поэтому новые учащиеся не смогут его найти. Те, кто уже проходит курс, продолжат обучение без изменений.",
			"unpublishConfirmCta": "Снять с публикации",
			"relistConfirmTitle": "Вернуть курс в каталог?",
			"relistConfirmBody": "Курс снова появится в каталоге, и новые учащиеся смогут на него записаться.",
			"relistConfirmCta": "Вернуться в каталог",
			"unpublished": "Курс не опубликован",
			"relisted": "Курс возвращен в каталог"
		},
		"categories": {
			"exam": "Подготовка к экзаменам",
			"language": "Языки",
			"science": "Наука",
			"humanities": "Гуманитарные науки",
			"tech": "Технологии",
			"business": "Бизнес",
			"medicine": "Медицина",
			"other": "Другое"
		},
		"sources": {
			"authorMaterials": "{count, plural, one {# авторский материал} few {# авторских материала} many {# авторских материалов} other {# авторского материала}}",
			"hint": "Файлы автора закрыты: нет списка, нет предпросмотра, нет скачивания. Содержание доступно вам через заметки, тесты и ответы репетитора."
		},
		"tutor": {
			"notice": "Ответы основаны на материалах автора курса. Сами источники закрыты.",
			"aiDisclaimer": "ИИ может ошибаться — проверяйте важную информацию."
		},
		"update": {
			"pill": "Доступна версия {version}",
			"title": "Доступна версия {version}",
			"subtitle": "Вы изучаете версию {current}.",
			"warningTitle": "Что изменится при обновлении",
			"warningBody": "{count, plural, one {# пройденная вами тема была изменена} few {# пройденные вами темы были изменены} many {# пройденных вами тем были изменены} other {# пройденной вами темы было изменено}} — они будут перестроены, прогресс по ним сбросится. Пройденные и неизмененные темы останутся без изменений.",
			"warningBodySafe": "Измененные темы пересобираются с нуля. Ни одна из завершенных вами тем не была изменена, поэтому прогресс не будет потерян.",
			"summary": "Добавлено {added} · изменено {changed} · удалено {removed} · без изменений {unchanged}",
			"kind": {
				"added": "Новая тема",
				"changed": "Обновлено",
				"renamed": "Переименовано",
				"removed": "Удалено",
				"unchanged": "Без изменений"
			},
			"noStructuralChanges": "Структура не изменилась",
			"apply": "Обновить",
			"later": "Не сейчас",
			"hide": "Скрыть до следующей версии",
			"applied": "Курс обновлен до версии {version}",
			"error": "Не удалось обновить курс",
			"willReset": "будет пересобрана, прогресс сбросится",
			"frozen": "уже пройдена — остается без изменений",
			"hideError": "Не удалось скрыть уведомление"
		},
		"fork": {
			"title": "Использовать как основу",
			"subtitle": "Вы получите собственную копию: структуру и сгенерированные материалы, прогресс начнется с нуля.",
			"cta": "Использовать как основу",
			"ctaTitle": "Хотите использовать свои материалы?",
			"ctaHint": "Создайте копию курса и добавьте в нее свои источники.",
			"sources": "Источники автора",
			"sourcesHint": "Не передаются — файлы автора остаются закрытыми",
			"note": "После копирования добавьте свои источники и пересоберите программу.",
			"submit": "Создать копию",
			"success": "Копия создана — добавьте свои источники",
			"error": "Не удалось скопировать курс"
		},
		"card": {
			"topics": "{count, plural, one {# тема} few {# темы} many {# тем} other {# темы}}",
			"version": "v{version}",
			"start": "Начать курс",
			"enrolled": "Курс добавлен в ваш список",
			"enrollError": "Не удалось начать курс",
			"enrollments": "{count, plural, one {# студент} few {# студента} many {# студентов} other {# студента}}",
			"alreadyEnrolled": "Вы уже проходите этот курс"
		},
		"catalog": {
			"title": "Каталог курсов",
			"subtitle": "Курсы от других авторов — с программой, заметками и репетитором",
			"back": "Курсы",
			"search": "Поиск курсов",
			"categoryAll": "Все категории",
			"localeAll": "Все языки",
			"emptyTitle": "Опубликованных курсов пока нет",
			"emptyHint": "Опубликуйте один из своих курсов в качестве шаблона — он появится здесь.",
			"emptyCta": "Перейти к моим курсам",
			"noMatches": "Ничего не найдено по этим фильтрам",
			"noMatchesHint": "Попробуйте изменить категорию или язык.",
			"resetFilters": "Сбросить фильтры",
			"errorTitle": "Не удалось загрузить каталог",
			"errorHint": "Проверьте подключение к сети и повторите попытку.",
			"retry": "Повторить попытку",
			"offlineTitle": "Для работы каталога требуется подключение",
			"offlineHint": "Опубликованные курсы не хранятся на устройстве — список загрузится при восстановлении соединения.",
			"tabsLabel": "Вкладки каталога",
			"tabCatalog": "Каталог",
			"tabMine": "Мои шаблоны"
		},
		"status": {
			"draft": "Черновик",
			"published": "В каталоге",
			"unpublished": "Неопубликован"
		},
		"review": {
			"pending": "На проверке",
			"manual": "Ручная проверка",
			"rejected": "Проверка не пройдена",
			"rejectedTitle": "Курс не прошёл проверку",
			"rejectedBody": "Курс не соответствует правилам каталога и не был опубликован. Исправьте замечания и опубликуйте новую версию.",
			"noReason": "Подробности не указаны. Проверьте курс на наличие запрещенных тем: насилие, контент для взрослых, оружие, наркотики, чужие персональные данные.",
			"appeal": "Если вы считаете, что это ошибка, свяжитесь с поддержкой — специалист проверит курс."
		},
		"mine": {
			"open": "Открыть",
			"unpublish": "Снять с публикации",
			"republish": "Вернуть в каталог",
			"unpublishConfirmTitle": "Снять курс с публикации?",
			"unpublishConfirmBody": "Новые пользователи не смогут начать обучение. У тех, кто уже учится, курс и его версия сохранятся.",
			"unpublishConfirmCta": "Снять с публикации",
			"unpublishedToast": "Курс снят с публикации — новые записи закрыты",
			"restoredToast": "Курс снова в каталоге",
			"statusError": "Не удалось изменить статус",
			"draftHint": "Версии еще не опубликованы. Опубликуйте курс в его заголовке — тогда он появится в каталоге.",
			"versionsCount": "{count, plural, one {# версия} few {# версии} many {# версий} other {# версий}}",
			"emptyTitle": "Вы еще ничего не опубликовали",
			"emptyHint": "Опубликуйте один из своих курсов как шаблон — он появится здесь и в каталоге.",
			"errorTitle": "Не удалось загрузить ваши шаблоны"
		},
		"detail": {
			"back": "Каталог",
			"noDescription": "Автор не добавил описание.",
			"outlineTitle": "Программа",
			"outlineEmpty": "Программа появится, когда автор опубликует версию.",
			"sourcesTitle": "Файлы автора остаются закрытыми",
			"startHint": "Вы получите собственный курс, созданный на основе этой версии: программу, заметки, карточки и тесты.",
			"closedHint": "Автор закрыл запись на курс. Уже начатые курсы продолжат работу.",
			"alreadyEnrolled": "У вас уже есть курс по этому шаблону.",
			"continue": "Продолжить курс",
			"authorTitle": "Ваш шаблон",
			"authorHint": "Снятие с публикации закрывает запись для новых пользователей; у тех, кто уже учится, курс сохраняется. Новая версия публикуется из заголовка курса.",
			"notFoundTitle": "Курс не найден",
			"notFoundHint": "Возможно, автор удалил этот шаблон.",
			"errorTitle": "Не удалось загрузить курс"
		}
	},
	"catalog": {
		"title": "Каталог курсов",
		"subtitle": "Готовые программы и курсы от других авторов — выберите подходящий и приступайте",
		"back": "Курсы",
		"scopeLabel": "Разделы каталога",
		"scopeCatalog": "Каталог",
		"scopeMine": "Мои шаблоны",
		"emptyTitle": "Каталог пока пуст",
		"emptyHint": "Здесь появятся готовые программы подготовки к экзаменам и курсы, опубликованные другими авторами.",
		"noMatches": "Ничего не найдено по этим фильтрам",
		"noMatchesHint": "Попробуйте изменить направление, тип или язык.",
		"resetFilters": "Сбросить фильтры",
		"errorTitle": "Не удалось загрузить каталог",
		"errorHint": "Проверьте подключение к сети и попробуйте снова.",
		"retry": "Попробовать снова",
		"offlineTitle": "Для работы каталога требуется сеть",
		"offlineHint": "Каталог не хранится на устройстве — список загрузится, когда вы снова будете онлайн.",
		"loadMore": "Показать ещё",
		"filters": {
			"subjectArea": "Направление",
			"subjectAreaAll": "Все направления",
			"purpose": "Тип",
			"purposeAll": "Любой тип",
			"origin": "Источник",
			"originAll": "Любой источник",
			"examSystem": "Экзамен",
			"examSystemAll": "Любой экзамен",
			"locale": "Язык",
			"localeAll": "Все языки",
			"sort": "Сортировка",
			"search": "Поиск по каталогу",
			"pricing": "Цена",
			"pricingAll": "Любая цена"
		},
		"subjectAreas": {
			"math": "Математика",
			"science": "Естественные науки",
			"languages": "Языки",
			"humanities": "Гуманитарные науки",
			"tech": "IT и программирование",
			"business": "Бизнес и финансы",
			"medicine": "Медицина",
			"arts": "Искусство и дизайн",
			"countries": "Страны",
			"other": "Другое"
		},
		"purposes": {
			"exam": "Подготовка к экзаменам",
			"general": "Общий курс"
		},
		"pricing": {
			"free": "Бесплатные",
			"paid": "Платные"
		},
		"origins": {
			"official": "Официальные программы",
			"author": "От авторов"
		},
		"sorts": {
			"popular": "Сначала популярные",
			"new": "Сначала новые"
		},
		"card": {
			"official": "Официальная программа",
			"inProgress": "Обучение начато",
			"byAuthor": "автор: {name}",
			"start": "Начать курс",
			"continue": "Продолжить курс",
			"started": "Курс добавлен в ваш список",
			"alreadyStarted": "Вы уже проходите этот курс",
			"startError": "Не удалось начать курс",
			"hours": "≈{count, plural, one {# час} few {# часа} many {# часов} other {# часа}}",
			"topics": "{count, plural, one {# тема} few {# темы} many {# тем} other {# темы}}",
			"enrollments": "{count, plural, one {# студент} few {# студента} many {# студентов} other {# студента}}",
			"reviewPending": "На проверке",
			"reviewRejected": "Отклонено"
		},
		"publish": {
			"subjectAreaLabel": "Направление",
			"subjectAreaPlaceholder": "Выберите направление",
			"purposeLabel": "Тип курса",
			"levelLabel": "Уровень",
			"levelNone": "Не указан",
			"examSystemLabel": "Экзамен",
			"examSystemNone": "Не указан",
			"localeLabel": "Язык курса",
			"translationNotice": "Название и описание будут переведены на все языки платформы, чтобы учащиеся могли найти курс на своем языке. Содержание курса не переводится."
		},
		"levels": {
			"beginner": "Начальный",
			"intermediate": "Средний",
			"advanced": "Продвинутый"
		},
		"seo": {
			"title": "Каталог курсов",
			"description": "Готовые курсы и программы подготовки к экзаменам: конспекты, карточки, тесты и AI-репетитор внутри каждого курса.",
			"aboutTitle": "Что такое каталог курсов StudyHub",
			"aboutBody": "В каталоге собраны программы подготовки к экзаменам от платформы и готовые курсы, опубликованные авторами. У каждого курса есть программа по разделам и темам, конспекты, карточки и тесты, а AI-репетитор отвечает по материалам этого курса. Начать можно с любого — прогресс и расписание подстроятся под вашу нагрузку."
		},
		"public": {
			"startSoon": "Запись на курс скоро появится",
			"notFoundTitle": "Курс не найден",
			"notFoundHint": "Курс снят с публикации или ссылка устарела. Посмотрите, что есть в каталоге.",
			"backToCatalog": "В каталог курсов"
		}
	},
	"cover": {
		"entry": "Обложка курса",
		"title": "Обложка курса",
		"subtitle": "Обложка отображается на карточке курса, в каталоге и в заголовке курса.",
		"promptLabel": "Что изменить (необязательно)",
		"promptPlaceholder": "Например: более теплые тона, добавить глобус",
		"promptHint": "Обложки не содержат текста, людей или логотипов — такие запросы игнорируются, чтобы изображение подходило для любого языка.",
		"regenerate": "Создать новую",
		"regenerateQueued": "Создаем новую обложку — она появится через мгновение",
		"regenerateError": "Не удалось запустить генерацию",
		"upload": "Загрузить свою",
		"uploadDone": "Обложка обновлена",
		"uploadError": "Не удалось загрузить обложку",
		"uploadBadType": "Только файлы JPEG, PNG или WebP",
		"uploadTooLarge": "Файл больше 5 МБ",
		"preview": "Просмотреть обложку",
		"previewTitle": "Обложка курса"
	},
	"language": {
		"prompt": "Этот курс на языке {courseLanguage}. Перевести его на {userLanguage}?",
		"translate": "Перевести",
		"keepOriginal": "Оставить оригинал",
		"translating": "Переводим структуру курса — названия тем обновятся через мгновение",
		"error": "Не удалось изменить язык курса",
		"originalBadge": "Оригинал: {language}",
		"topicError": "Не удалось перевести эту тему — она останется на исходном языке",
		"topicQuota": "Достигнут дневной лимит генерации — эта тема останется на исходном языке"
	},
	"audio": {
		"originalLanguage": "Озвучено на языке оригинала ({language}) — аудио не переводится вместе с текстом.",
		"revoice": "Переозвучить на {language}",
		"revoiceQueued": "Озвучивание запущено — оно появится, когда будет готово",
		"revoiceError": "Не удалось запустить озвучивание"
	},
	"draft": {
		"badge": "Черновик программы",
		"buildingTitle": "Пересобираем программу…",
		"buildingHint": "Обычно это занимает около минуты. Темы обновятся сами.",
		"failedTitle": "Не удалось пересобрать программу",
		"failedHint": "Прежние темы на месте — можно повторить попытку или утвердить программу как есть.",
		"retry": "Попробовать ещё раз",
		"rebuildStarted": "Собираем программу заново",
		"rebuildAlreadyRunning": "Сборка этой программы уже идёт",
		"rebuildError": "Не удалось запустить пересборку",
		"confirmed": "Программа утверждена — можно начинать",
		"confirmError": "Не удалось утвердить программу",
		"actions": {
			"label": "Черновик программы",
			"confirm": "Утвердить программу",
			"edit": "Изменить программу",
			"rebuild": "Пересобрать",
			"rebuilding": "Пересобираем…"
		},
		"adjust": {
			"title": "Скорректировать черновик по результатам теста?",
			"hint": "Слабые темы разберём глубже, сильные пройдёте экспрессом. Программу это не перекроит — предложим, что добавить.",
			"action": "Подобрать корректировку",
			"later": "Не сейчас",
			"readyTitle": "Что предлагаем добавить",
			"readyHint": "Порядок разделов не меняется — это дополнения внутрь существующих модулей. Снимите лишнее и применяйте.",
			"rowModule": "В модуль «{module}»",
			"rowBecause": "В модуль «{module}» — по итогам темы «{topic}»",
			"summary": "{count, plural, one {# тема} few {# темы} other {# тем}} к добавлению",
			"applying": "Добавляем: {done} из {total}",
			"apply": "Добавить в программу",
			"discard": "Не добавлять",
			"applied": "{count, plural, one {Добавлена # тема} few {Добавлено # темы} other {Добавлено # тем}}",
			"applyFailed": "Не удалось добавить всё: успели {count, plural, one {# тему} few {# темы} other {# тем}}",
			"emptyTitle": "Корректировать нечего",
			"emptyNoWeak": "Тест не выявил слабых тем — программа подходит как есть.",
			"emptyNoRoom": "Программа уже максимального размера — добавлять темы некуда.",
			"close": "Понятно",
			"failedTitle": "Не удалось подобрать корректировку",
			"failedHint": "Программа не изменилась. Можно повторить попытку или утвердить черновик как есть.",
			"retry": "Попробовать ещё раз"
		},
		"sources": {
			"title": "{count, plural, one {# материал ещё не учтён в черновике} few {# материала ещё не учтены в черновике} other {# материалов ещё не учтены в черновике}}",
			"titleUnknown": "Новые материалы ещё не учтены в черновике",
			"hint": "Черновик можно пересобрать целиком — прогресса в нём пока нет, терять нечего.",
			"update": "Обновить черновик",
			"updating": "Пересобираем…",
			"keep": "Оставить как есть",
			"kept": "Оставили как есть — программа не изменилась",
			"keepError": "Не удалось сохранить выбор"
		},
		"passport": {
			"eyebrow": "Тема черновика",
			"noDescription": "Описание темы не заполнено — в программе она останется под этим названием.",
			"contentLater": "Конспект, карточки и тест по теме появятся после утверждения программы — их собирают по мере прохождения, а не все сразу.",
			"openPlan": "Все темы",
			"noTopicTitle": "Тема не выбрана",
			"noTopicHint": "Откройте программу и выберите тему, чтобы посмотреть, о чём она."
		},
		"ready": {
			"title": "Программа готова — начинаем",
			"hint": "Первая тема открыта. Можно приступать.",
			"step": "Программа утверждена",
			"continue": "Начать"
		}
	},
	"intro": {
		"title": "Курс — программа из ваших материалов",
		"body": "ИИ разбивает загруженное на темы и выстраивает порядок. Каждая тема ведёт маршрутом: разобраться → проверить себя → добрать.",
		"bullets": [
			"Программа собирается из источников, а не пишется руками",
			"Занятия сами раскладываются по календарю до экзамена",
			"Готовую программу можно взять в каталоге"
		]
	},
	"catalogIntro": {
		"title": "Каталог — чужие программы, курс — ваш",
		"body": "Взятая отсюда программа становится вашим отдельным курсом — с собственным прогрессом, который начинается с нуля.",
		"bullets": [
			"Программа платформы генерируется, курс автора копируется",
			"Взятый курс не меняется, когда автор выпустит новую версию",
			"Материалы автора не переносятся — источники добавляете свои"
		]
	}
}
